module.exports = __webpack_public_path__ + "static/media/home-united-logo.f69dc943.png";